import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.ContractConsent.FindPublic.IParams;
type Response = Api.Core.ContractConsent.FindPublic.IResponse;
type Headers = Api.Core.ContractConsent.FindPublic.IHeaders;
const url = '/api/Public/ContractConsent/:contractConsentId';
export default async function contractConsentFindPublicApi({
  params,
  access_token,
}: {
  params: Params;
  access_token: string;
}): Promise<Api.Res<Response>> {
  return await executeServerApi<Params, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params, null),
    headers: { ...getDefaultHeaders(), Authorization: `Bearer ${access_token}` },
  });
}
